import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./shared.css";
import "./App.css";
import AnimatedBackground from "./components/AnimatedBackground";
import Navigation from "./components/Navigation";
import Home from "./pages/Home";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import NotFound from "./pages/NotFound";
import { LoadingProvider } from "./contexts/LoadingContext";

function App() {
  return (
    <Router>
      <LoadingProvider>
        <div className="App">
          <AnimatedBackground />
          <Navigation />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <footer className="site-footer">
            <p>&copy; 2026 Alec Potluri. All rights reserved.</p>
          </footer>
        </div>
      </LoadingProvider>
    </Router>
  );
}

export default App;
